import { Component, OnInit } from '@angular/core';
import { PortfolioService } from '../../../../core/services/api/portfolio.service';
import { ErrorService } from '../../../../core/services/error.service';
import { PorfolioReport } from '../../../../core/models/portfolio/portfolio-report';
import { AttachmentAudience } from '../../../../core/enum/attachment-audience.enum';
import { finalize } from 'rxjs';

@Component({
    selector: 'app-reports',
    templateUrl: './reports.component.html',
    standalone: false
})
export class ReportsComponent implements OnInit {
  constructor(
    private readonly portfolioService: PortfolioService,
    private readonly errorService: ErrorService,
  ) {}

  isLoading: boolean = true;
  reports: PorfolioReport[] = [];

  AttachmentAudience: typeof AttachmentAudience = AttachmentAudience;

  ngOnInit(): void {
    this.getReports();
  }

  getReports() {
    this.portfolioService
      .getReports()
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe({
        next: (data) => {
          this.reports = data?.data ?? [];
        },
        error: (err) => {
          this.errorService.showError(err);
        },
      });
  }

  openUrl(url: string) {
    window.open(url);
  }
}
